import moment from "moment";
import WidgetSkeleton from "./WidgetSkeleton";
import WidgetDataLabel from "./WidgetDataLabel";
import WidgetMessage, { BaseWidgetMessages } from "./WidgetMessage";
import { Card, Col } from "react-bootstrap";
import { ThemedSpan } from "../../../components/utilities";
import { useReviewsSummaryData } from "../hooks/ReviewsSummaryContext";
import { toCommas } from "../../../helpers/numbers";

const WidgetBody = () => {
    const formattedDate = moment().month(0).format('MMMM YYYY');
    const { data, error } = useReviewsSummaryData();
    
    if (error) {
        return <WidgetMessage icon={['fas', 'exclamation']} message={BaseWidgetMessages.Error} />
    }

    if (!data || data.length < 1) {
        return <WidgetMessage message={BaseWidgetMessages.NoResult} />
    }

    return (
        <>
            <WidgetDataLabel label={`Completed since ${formattedDate}`} value={toCommas(data.completedThisYear)} />
            <WidgetDataLabel label={`PRD to be sent`} value={toCommas(data.prdToBeSent)} />
            <WidgetDataLabel label={`Meeting to be scheduled`} value={toCommas(data.meetingToBeScheduled)} />
            <WidgetDataLabel label={`Meeting scheduled`} value={toCommas(data.meetingScheduled)} />
            <WidgetDataLabel label={`Meeting note to be updated`} value={toCommas(data.meetingNoteToBeUpdated)} />
            <WidgetDataLabel label={`Follow up to be sent`} value={toCommas(data.followUpToBeSent)} />
        </>
    )
}

export const ReviewsWidget = () => {
    const { data, isFetching, isLoading } = useReviewsSummaryData();
    const { onHold } = data || { onHold: 0 };

    if (isFetching || isLoading) {
        return <WidgetSkeleton />
    }

    return (
        <Col xs={12} sm={12} md={6} lg={6} xl={4}>
            <a className="text-reset text-decoration-none" href={"/management/reviews/detailed"}>
                <Card className="overflow-hidden" style={{ height: "300px", color: "dodgerblue" }}>
                    <Card.Body>
                        <Card.Title className="row gx-1 pb-2">
                            <div className="col-4" style={{ fontSize: "18px" }}>
                                <ThemedSpan variant="primary" className="fw-bold">Reviews</ThemedSpan>
                            </div>
                            <div className="col-8 fs-6 text-end">
                                <ThemedSpan variant="danger" className="fw-bold">On hold: {onHold}</ThemedSpan>
                            </div>
                        </Card.Title>
                        <Card.Text as="div" className="row g-2">
                            <WidgetBody />
                        </Card.Text>
                    </Card.Body>
                </Card>
            </a>
        </Col>
    )
}